import { createAction, props } from "@ngrx/store";

export const setStepperIndex = createAction("[Stepper] Set stepper index", props<{ data: number }>());
export const resetStepper = createAction("[Stepper] Reset");